'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _messages = require('common/messages');

var _products = require('./products.html');

var _products2 = _interopRequireDefault(_products);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _products2.default,
  bindings: {
    flex: '@',
    layout: '@',
    alerts: '<',
    administrationUnits: '<',
    animalTypes: '<',
    categories: '<',
    user: '<',
    products: '<',
    searchCriteria: '<',
    searchTypes: '<',
    query: '<',
    limitOptions: '<'
  },
  controller: function () {
    function ProductsComponent($mdDialog, $mdMenu, $scope, $state, AccountService, AuthService, LoadingService, ProductService, ProductsService, ToastService, UsageDataService) {
      'ngInject';

      var _this = this;

      _classCallCheck(this, ProductsComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $mdMenu: $mdMenu,
        $scope: $scope,
        $state: $state,
        AccountService: AccountService,
        AuthService: AuthService,
        LoadingService: LoadingService,
        ProductService: ProductService,
        ProductsService: ProductsService,
        ToastService: ToastService,
        UsageDataService: UsageDataService
      });

      this.onPaginationChanged = function (page, take) {
        _this.query = _extends({}, _this.query, {
          page: page,
          take: take
        });

        _this.refreshResults();
      };

      this.onOrderChanged = function (order) {
        var direction = order.indexOf('-') !== -1 ? 'desc' : 'asc';
        var orderBy = order.replace('-', '');

        _this.query = _extends({}, _this.query, {
          direction: direction,
          orderBy: orderBy
        });

        _this.refreshResults();
      };
    }

    _createClass(ProductsComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.searchCriteria = this.searchCriteria || {};
        this.selectedProducts = [];
      }
    }, {
      key: 'refreshResults',
      value: function refreshResults() {
        var _this2 = this;

        this.ProductsService.setQuery(this.query);
        this.promise = undefined;
        switch (this.searchCriteria.selectedSearchType) {
          case 'Search by Ingredient Name':
            if (this.searchCriteria.selectedUserIngredient) {
              this.promise = this.ProductsService.getProductsByIngredient(this.searchCriteria.selectedUserIngredient.UserIngredientId);
            }
            break;
          case 'Search by System Ingredient Name':
            if (this.searchCriteria.selectedSystemIngredient) {
              this.promise = this.ProductsService.getProductsBySystemIngredient(this.searchCriteria.selectedSystemIngredient.SystemIngredientId);
            }
            break;
          case 'Search by Member':
            if (this.searchCriteria.selectedCompany) {
              this.promise = this.ProductsService.getProductsByMember(this.searchCriteria.selectedCompany.MemberId);
            }
            break;
          case 'Search by Species':
            if (this.searchCriteria.selectedSpecies) {
              this.promise = this.ProductsService.getProductsBySpecies(this.searchCriteria.selectedSpecies);
            }
            break;
          case 'Missing - Containers Shipped Data':
            this.promise = this.ProductsService.getProductsMissingSalesData();
            break;
          case 'Missing - Product Information':
            this.promise = this.ProductsService.getProductsMissingProductInfo();
            break;
          default:
            this.promise = this.ProductsService.getProducts();
        }

        this.promise = this.promise || this.ProductsService.getProducts();

        this.promise.then(function (r) {
          _this2.products = {
            Count: r.data.Count,
            Data: r.data.Data
          };
        }).catch(function (error) {
          return _this2.ToastService.showError(error);
        });
      }
    }, {
      key: 'onSearchChanged',
      value: function onSearchChanged(_ref) {
        var searchCriteria = _ref.searchCriteria;

        this.searchCriteria = searchCriteria;
        this.query = _extends({}, this.query, {
          searchText: this.searchCriteria.searchText
        });

        this.refreshResults();
      }
    }, {
      key: 'getSignatureImage',
      value: function getSignatureImage(signature) {
        return signature && signature.length ? 'lock' : 'lock_open';
      }
    }, {
      key: 'onEditClicked',
      value: function onEditClicked(productId) {
        this.$state.go('productEdit', { id: productId });
      }
    }, {
      key: 'deleteSignature',
      value: function deleteSignature(product) {
        var _this3 = this;

        if (this.AuthService.isSysAdmin && product.Signature && product.Signature.length) {
          var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once confirmed, the product signature will be removed.').ok('Remove Signature').cancel('Cancel');

          this.$mdDialog.show(confirm).then(function () {
            _this3.ProductsService.removeSignature(product.ProductId).then(function () {
              product.Signature = null;
              _this3.ToastService.showSuccess(_messages.PRODUCT_SIGNATURE_DELETED);
            }).catch(function (error) {
              return _this3.ToastService.showError(error);
            });
          });
        }
      }
    }, {
      key: 'setDiscontinued',
      value: function setDiscontinued(product) {
        var _this4 = this;

        if (!product.Discontinued) {
          var confirm = this.$mdDialog.confirm().title('Are you sure you want to discontinue this product?').textContent(_messages.PRODUCT_DISCONTINUATION_GUIDANCE).ok('Discontinue Product').cancel('Cancel');

          this.$mdDialog.show(confirm).then(function () {
            // In this instance WITH the dialog, the value of product.Discontinued is correctly updated by the time we get here
            _this4.ProductsService.setDiscontinuedStatus(product.ProductId, product.Discontinued).then(function () {
              _this4.ToastService.showSuccess(_messages.PRODUCT_DISCONTINUED_EDITED);
            }).catch(function (error) {
              return _this4.ToastService.showError(error);
            });
          }).catch(function () {
            product.Discontinued = false;
            return false;
          });
        } else {
          // In this instance WITHOUT the dialog, the value of product.Discontinued hasn't had a chance to update yet so we have to pass its inverse
          this.ProductsService.setDiscontinuedStatus(product.ProductId, !product.Discontinued).then(function () {
            _this4.ToastService.showSuccess(_messages.PRODUCT_DISCONTINUED_EDITED);
          }).catch(function (error) {
            return _this4.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'onViewClicked',
      value: function onViewClicked(productId, index) {
        var _this5 = this;

        this.LoadingService.start();
        this.ProductService.getProduct(productId).then(function (r) {
          var product = r.data;

          var scope = _angular2.default.extend(_this5.$scope.$new(true), {
            product: product,
            units: _this5.products.Data[index].UnitPerContainer,
            categories: _this5.categories,
            administrationUnits: _this5.administrationUnits,
            administrations: product.tblDoses,
            showUsageGuidance: false,
            unitsDisplay: _this5.ProductService.getUnitsDisplay(product),
            locked: true,
            viewOnly: true
          });

          _this5.LoadingService.stop();

          _this5.$mdDialog.show({
            clickOutsideToClose: true,
            fullscreen: true,
            scope: scope,
            template: product.IsTreat ? '\n            <md-dialog class="flex-85" style="max-height: 90%">\n              <md-dialog-content class="naers-dialog-content">\n                <dialog-close/>\n                <treat-information\n                  administration-units="administrationUnits" \n                  categories="categories"\n                  product="product"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  view-only="viewOnly"\n                  label-valid="true"\n                  show-header="true">\n                </treat-information>\n                <treat-admin-list flex\n                  units="units"\n                  administrations="administrations"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  show-header="true">\n                </treat-admin-list>\n                <product-ingredient-list flex ingredients="product.tblProduct_UserIngredient"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  show-header="true">\n                </product-ingredient-list>\n                <usage-data flex usages="product.tblUsages" show-guidance="showUsageGuidance"\n                  locked="locked"\n                  show-header="true">\n                </usage-data>\n              </md-dialog-content>\n            </md-dialog>\n          ' : '\n            <md-dialog class="flex-85" style="max-height: 90%">\n              <md-dialog-content class="naers-dialog-content">\n                <dialog-close/>\n                <information\n                  administration-units="administrationUnits" \n                  categories="categories"\n                  product="product"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  view-only="viewOnly"\n                  label-valid="true"\n                  show-header="true">\n                </information>\n                <loading-admin-list flex\n                  ng-show="product.HasLoading"\n                  administrations="administrations"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  show-header="true">\n                </loading-admin-list>\n                <maintenance-admin-list flex\n                  units="units"\n                  administrations="administrations"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  show-header="true">\n                </maintenance-admin-list>\n                <product-ingredient-list flex ingredients="product.tblProduct_UserIngredient"\n                  units-display="unitsDisplay"\n                  locked="locked"\n                  show-header="true">\n                </product-ingredient-list>\n                <usage-data flex usages="product.tblUsages" show-guidance="showUsageGuidance"\n                  locked="locked"\n                  show-header="true">\n                </usage-data>\n              </md-dialog-content>\n            </md-dialog>\n          '
          });
        }).catch(function (error) {
          return _this5.ToastService.showError(error);
        }).finally(function () {
          return _this5.LoadingService.stop();
        });
      }
    }, {
      key: 'showUsages',
      value: function showUsages(quarterOnly) {
        var _this6 = this;

        var promise = void 0;
        if (quarterOnly) {
          promise = this.UsageDataService.getMissingQuarterUsageData();
        } else {
          promise = this.UsageDataService.getMissingUsageData();
        }

        promise.then(function (r) {
          var usages = r.data;

          if (usages && usages.length) {
            var scope = _angular2.default.extend(_this6.$scope.$new(true), {
              usages: usages,
              onUsageDataUpdated: function onUsageDataUpdated($event) {
                return _this6.onUsageDataUpdated($event);
              }
            });

            _this6.$mdDialog.show({
              clickOutsideToClose: true,
              fullscreen: true,
              scope: scope,
              template: '\n          <md-dialog class="flex-85" style="max-height: 90%">\n            <md-dialog-content>\n              <dialog-close/>\n              <bulk-usage-data\n                usages="usages"\n                on-usages-submitted="onUsageDataUpdated($event)">\n              </bulk-usage-data>\n            </md-dialog-content>\n          </md-dialog>\n          '
            });
          } else {
            _this6.$mdDialog.show(_this6.$mdDialog.alert().clickOutsideToClose(true).textContent('You are currently in compliance. No further action is required.').ariaLabel('No action required').ok('OK'));
          }
        }).catch(function (error) {
          return _this6.ToastService.showError(error);
        });
      }
    }, {
      key: 'onUsageDataUpdated',
      value: function onUsageDataUpdated($event) {
        var _this7 = this;

        if ($event && $event.usages) {
          this.UsageDataService.updateMissingUsageData($event.usages).then(function () {
            _this7.ToastService.showSuccess(_messages.USAGE_DATA_UPDATED);
            _this7.$mdDialog.hide();
            _this7.$state.reload();
          }).catch(function (error) {
            return _this7.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'onEditProductUsageClicked',
      value: function onEditProductUsageClicked(product) {
        var _this8 = this;

        this.ProductService.getProduct(product.ProductId).then(function (r) {
          var scope = _angular2.default.extend(_this8.$scope.$new(true), {
            dialogTitle: product.ProductName + ' - Number of Units Shipped (Shipping Data)',
            usages: _this8.ProductService.transformUsages(product.ProductId, product.DateIntroduced, r.data.tblUsages),
            usageDataChanged: function usageDataChanged($event) {
              return _this8.onProductUsageDataUpdated($event);
            }
          });

          _this8.$mdDialog.show({
            clickOutsideToClose: true,
            fullscreen: true,
            scope: scope,
            template: '\n            <md-dialog class="flex-85" style="max-height: 90%">\n              <md-dialog-content>\n                <dialog-close/>\n                <usage-data usages="usages"\n                  show-guidance="true"\n                  show-header="true"\n                  dialog-title="{{dialogTitle}}"\n                  show-action-buttons="true"\n                  usage-data-changed="usageDataChanged($event)"\n                  missing-message="Shipping data is currently in compliance for this product.">\n                </usage-data>\n              </md-dialog-content>\n          </md-dialog>'
          });
        }).catch(function (error) {
          return _this8.ToastService.showError(error);
        });
      }
    }, {
      key: 'onProductUsageDataUpdated',
      value: function onProductUsageDataUpdated($event) {
        var _this9 = this;

        if ($event && $event.usages) {
          this.UsageDataService.updateMissingUsageData($event.usages).then(function () {
            _this9.ToastService.showSuccess(_messages.USAGE_DATA_UPDATED);
            _this9.$mdDialog.hide();
          }).catch(function (error) {
            return _this9.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'alertClicked',
      value: function alertClicked(_ref2) {
        var alert = _ref2.alert;

        if (alert) {
          if (alert.AlertTypeID === 1) {
            this.searchCriteria = _extends({}, this.searchCriteria, {
              selectedSearchType: 'Missing - Product Information'
            });

            this.refreshResults();
          } else if (alert.AlertTypeID === 3) {
            if (this.AuthService.isSysAdmin) {
              this.searchCriteria = _extends({}, this.searchCriteria, {
                selectedSearchType: 'Missing - Containers Shipped Data'
              });

              this.refreshResults();
            } else {
              this.showUsages(false);
            }
          }
        }
      }
    }, {
      key: 'saveProductLabel',
      value: function saveProductLabel(_ref3) {
        var _this10 = this;

        var productId = _ref3.productId,
            productLabel = _ref3.productLabel;

        this.LoadingService.start();
        this.ProductService.uploadLabel(productId, productLabel).then(function () {
          _this10.ToastService.showSuccess(_messages.PRODUCT_LABEL_COMMITTED);
          _this10.$state.reload();
        }).catch(function (error) {
          return _this10.ToastService.showError(error);
        }).finally(function () {
          return _this10.LoadingService.stop();
        });
      }
    }, {
      key: 'updateDiscontinuedSetting',
      value: function updateDiscontinuedSetting(showDiscontinuedProducts) {
        var _this11 = this;

        this.AccountService.updateDiscontinuedPreference(this.user.UserId, showDiscontinuedProducts).then(function () {
          _this11.ToastService.showSuccess(_messages.DISCONTINUED_PREFERENCE_CHANGED);
          _this11.$state.reload();
        }).catch(function (error) {
          return _this11.ToastService.showError(error);
        });
      }
    }, {
      key: 'onDeleteClicked',
      value: function onDeleteClicked(products) {
        var _this12 = this;

        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent(_messages.PRODUCT_DELETE_GUIDANCE).ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          var promises = [];
          for (var i = products.length - 1; i >= 0; i -= 1) {
            promises.push(_this12.ProductService.delete(products[i].ProductId));
          }

          Promise.all(promises).then(function () {
            _this12.ToastService.showSuccess(_messages.PRODUCT_DELETED);
            _this12.refreshResults();
            _this12.selectedProducts = [];
          }).catch(function (error) {
            return _this12.ToastService.showError(error);
          });
        });
      }
    }, {
      key: 'onBulkUnsignClicked',
      value: function onBulkUnsignClicked(products) {
        var _this13 = this;

        var confirm = this.$mdDialog.confirm().title('Are you sure?').textContent('Once confirmed, the product signature(s) will be removed.').ok('Delete').cancel('Cancel');

        this.$mdDialog.show(confirm).then(function () {
          var promises = [];
          for (var i = products.length - 1; i >= 0; i -= 1) {
            promises.push(_this13.ProductsService.removeSignature(products[i].ProductId));
          }

          Promise.all(promises).then(function () {
            _this13.ToastService.showSuccess(_messages.PRODUCT_SIGNATURE_DELETED);
            _this13.refreshResults();
            _this13.selectedProducts = [];
          }).catch(function (error) {
            return _this13.ToastService.showError(error);
          });
        });
      }
    }]);

    return ProductsComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/products/products.component.js